import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import { useAuth } from 'lib/auth';

export const verify = ({ data }) => {
  return axios.post(`/users/verification/phone/verify`, data);
};

export const useVerify = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  const { refetchUser } = useAuth();
  return useMutation({
    onMutate: async () => {},
    onError: (_, __, context) => {},
    onSuccess: (data) => {
      addNotification({
        type: 'success',
        title: data.message,
      });
      refetchUser();
    },
    ...config,
    mutationFn: verify,
  });
};
